import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vant from 'vant';
import 'vant/lib/index.css';
import './assets/css/global.scss';
// 打印的包
import print from 'vue3-print-nb';
// 国际化(中/英/西)
import i18n from '@/i18n';

const app = createApp(App);
// 时间格式化过滤器
import installFilter from '@/filter';
installFilter(app);
app.use(store).use(router).use(Vant).use(print).use(i18n).mount('#app');
